<template>
  <div id="Reference" class="container">
    <SfBreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs"
    />
    <div class="content">
      <SfHeading :level="1" :title="$t('Our references')" description="pageDescription"></SfHeading>
      <Locations ref="colissimoMap" :center="userCenter" :fly-to-store-zoom="userZoom"
                 :hasPopup=true :locations="locations"
                 v-on:isMapReady="getMapReady($event)" v-on:selectedLocation="setSelectedLocation($event)"
                 v-on:userPosition="getUserGeocode($event)">

        <template v-if="locations">
          <SfScrollable v-if="locations.length > 0" id="locations" :hide-text="$t('Hide')"
                        :show-text="$t('Show all')"
                        max-content-height="45vh">
            <template #view-all>
              <div class="display-none"></div>
            </template>
            <Location v-for="(location) in locations" :id="location.ref"
                    :key="location.ref"
                    :distance="location.distance"
                    :latlng="location.latlng"
                    :name="location.name"
                    :picture="location.picture"
                    :selectedLocationId="selectedLocationId"
            >
              <template #address>
                <div class="sf-store__address">
                  <p class="address">
                                        <span class="street">
                                            <span v-if="location.street"> {{
                                                location.street
                                              }}<br/></span>
                                        </span>
                    {{ location.postCode }} {{ location.city }}
                  </p>
                </div>
              </template>
              <template #openingTime>
                <div class="sf-store__openingTime" v-if="location.openingTimes">
                                <span class="opentBtnLink  color-tertiary" @click="opentTime">{{
                                    $t('Opening times')
                                  }}</span>

                  <div class="items">
                    <ul>
                      <li :key="i" v-for="(day,i) in location.openingTimes">
                                                    <span :class="[day.now?'day now':'day']"> {{ $t(day.day) }} : <span
                                                        class="time"> {{
                                                        day.time
                                                      }} </span>
                                                    </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </Location>
          </SfScrollable>
          <div v-else class="errorLocation">
            {{ $t('locations.notFound') }}
          </div>
        </template>
      </Locations>
    </div>
  </div>
</template>

<script>
import {SfBreadcrumbs,SfScrollable,SfHeading} from "@storefront-ui/vue"
import Api from "@/api/Api";
import Locations from '@/components/Locations/Locations.vue';
import {Location} from "@/models/location";
export default {
  name: "References",
  components: {
    SfBreadcrumbs,
    Locations,
    SfHeading,
    SfScrollable,
  },
  data() {
    return {
      breadcrumbs: null,
      loading: false,
      locale: this.$i18n.locale,
      locations:[],
      mapReady:false,
      userCenter: {lat: 46.50, lng: 2.00},
      userZoom: 5,
      initZoom: 5,
      selectedLocationId:null,
      selectedLocation:null
    }
  },
  created() {
    this.setBreadcrumbs();
  },
  mounted() {
    this.getLocations();
  },
  methods: {
    getUserGeocode(geocode) {
      this.UserGeocode = geocode
    },
    /*reverseGeocode(geocode) {

      Api.platform.reverseGeocoding(geocode).then((data) => {
        this.address = {...data};
        this.getRelais(data);
      }).catch((e) => {
          // console.error(e)
      })
    },*/
    setSelectedLocation(locationId) {
      this.selectedLocationId = locationId;
      this.selectedLocation = this.locations.find(location => location.ref === locationId);

    },

    getMapReady(event) {
      this.mapReady = event;
    },
    setBreadcrumbs() {
      this.breadcrumbs = [{
        text: this.$i18n.t('Home'),
        link: '/'
      }, {
        text: this.$i18n.t('Our references'),
      }];
    },
    getLocations(){
      Api.platform.getLocations().then((data)=>{
        for (let location of data) {
          this.locations.push(Location.of(location));
        }
      })
    },
    opentTime(item) {
      const openingElements = [...document.getElementsByClassName('isOpenTime')];
      item.target.parentElement.classList.toggle("isOpenTime");
      if (openingElements) {
        openingElements.forEach((element) => {
          if (element !== item.target.parentElement) {
            element.classList.remove('isOpenTime')
          }
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.error-msg {
  text-align: center;
}

h1, h2, h3 {
  text-transform: uppercase;
}

h2 {
  font-weight: bold;
  margin-top: var(--spacer-xl);
  margin-bottom: var(--spacer-lg);
}

h3 {
  font-weight: 500;
  margin-top: var(--spacer-lg);
  margin-bottom: var(--spacer-base);
}

p {
  margin: var(--spacer-base) 0;
}

.errorRelais {
  background: var(--c-danger);
  color: #ffffff;
  font-size: var(--font-size--lg);
  margin: 20px;
  padding: 20px;
  border-radius: 2px;
}

::v-deep {

  .sf-store-locator {
    overflow: hidden;
    --store-locator-map-height:60vh;
    flex: 1;
    flex-direction: row;
    align-self: stretch;
    @include for-mobile {
      flex-direction: column;
    }
    @include for-tablet {
      flex-direction: column;
    }

    &__wrapper {
      height: 100%;
      @include for-mobile {
        flex-direction: column;
        padding: 0 20px;
      }
      @include for-tablet {
        flex-direction: column;
      }
    }

    &__map-wrapper {
      flex: 1;
      align-self: stretch;
      @include for-mobile {
        order: 0;
        min-height: 50vh;
      }
      @include for-tablet {
        order: 0;
      }
    }

    &__map {
      position: absolute;
      height: 100%;
      @include for-tablet {
        position: relative;
        min-height: 50vh;
      }
      @include for-mobile {
        position: relative;
        min-height: 25vh;
      }
    }

    &__list {
      z-index: 1;
      background-color: #fff;
      box-shadow: -20px 0 20px -15px rgba(0,0,0,0.25);
      height: 100%;
      display: flex;
      flex-direction: column;
      align-self: stretch;
      --scrollable-max-height:60vh;
      @include for-mobile {
        padding: 10px 0;
        order: 1;
        .sf-scrollable__content {
          --scrollable-max-height: 35vh !important;
        }
      }
      @include for-tablet {
        padding: 10px 0;
        order: 1;
        .sf-scrollable__content {
          --scrollable-max-height: 25vh !important;
        }
      }
    }
  }
  .sf-store {
    padding: var(--spacer-xs) var(--spacer-sm) var(--spacer-xs) 0;
    margin-top: 0;
    position: relative;
    @include for-mobile {
      padding: var(--spacer-xs);
    }

    &__distance {
      position: absolute;
      right: 10px;
      flex: none;
      margin: 0 0 0 auto;
      @include for-mobile {
        position: absolute;
        right: 10px;
      }
      @include for-tablet {
        position: absolute;
        right: 10px;
      }
    }

    &__info {
      flex: 1;
      width: 100%;
      @include for-mobile {
        margin-top: 20px;
      }
      @include for-tablet {
        margin-top: 20px;
      }
    }


    .sf-radio {
      width: 100%;

      &__content {
        margin-left: 10px;
      }

      &__container {
        padding-bottom: 0;
        flex: 1;
        @include for-mobile {
          padding: 0;
        }
      }

      &.is-active {
        background: transparent;
      }

    }

    &.selected {
      background: var(--c-light);
    }

    &__address {
      margin-bottom: 0;
      color:var(--c-text);
      font-size: var(--font-size--xs);

      p {
        margin: 0;
      }
    }

    &__openingTime {
      .opentBtnLink {
        display: block;
        font-size: var(--font-size--sm);
        margin-left: 50px;
        cursor: pointer;
        text-decoration: underline;
        @include for-mobile {
          margin-left: 35px;
        }
      }

      .items {
        display: none;
        opacity: 0;
        transition: 0.3s ease opacity;

        ul {
          list-style: none;
          padding-left: 50px;
          @include for-mobile {
            margin-left: 35px;
          }

          li {
            padding: 0;
            line-height: 1;

            .day {
              font-size: var(--font-size--xs);

              &.now {
                font-weight: bold;
              }
            }
          }
        }
      }

      &.isOpenTime {
        .items {
          display: block;
          opacity: 1;

          ul {
            margin: 0;
          }
        }
      }


    }
  }
}


</style>